"use client";

import type { BabyNameEntry } from "@/lib/api/baby-names";
import Badge from "@ishvaram/ui/Badge";
import { ScoreBadge } from "@ishvaram/ui/ScoreBadge";

interface NameCardProps {
  entry: BabyNameEntry;
  selected: boolean;
  onToggle: () => void;
}

export function NameCard({ entry, selected, onToggle }: NameCardProps) {
  const genderVariant =
    entry.gender === "male" ? "accent" : entry.gender === "female" ? "error" : "accent";

  return (
    <div
      className={`card-sacred p-4 transition-all duration-200 cursor-pointer border-2 ${
        selected ? "border-ish-accent bg-ish-accent-light" : "border-transparent"
      }`}
      onClick={onToggle}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-serif text-base font-bold text-ish-dark truncate">{entry.name}</h3>
            <Badge label={entry.gender} variant={genderVariant} className="capitalize" />
          </div>
          <p className="text-sm text-ish-text-muted mb-1">{entry.name_hi}</p>
          <p className="text-[13px] leading-snug text-ish-text-muted">{entry.meaning}</p>
          <div className="mt-2 flex items-center gap-3 text-[11px] text-ish-text-faint font-medium">
            <span>Letter: {entry.starting_letter}</span>
            <span>Name No: {entry.name_number}</span>
            <span>{entry.origin}</span>
          </div>
        </div>
        <div className="flex-shrink-0 flex flex-col items-center">
          <ScoreBadge score={entry.compatibility_score} max={10} size="lg" />
          <span className="text-[10px] font-bold uppercase tracking-widest mt-1 text-ish-text-faint">
            {entry.compatibility_score >= 9
              ? "Excellent"
              : entry.compatibility_score >= 7
                ? "Good"
                : "Fair"}
          </span>
        </div>
      </div>
      {selected && (
        <div className="mt-2 text-[11px] font-bold text-center rounded py-1 text-ish-accent bg-ish-accent/10">
          Added to shortlist
        </div>
      )}
    </div>
  );
}
